import { FC } from 'react';
import { useTheme } from '@mui/material';
import CreateApiKeyForm from './CreateApiKeyForm';
import ModalDialog from '../../common/components/ModalDialog';
import { ApiKeyRoleType, CreateApiKeyInput } from '../types/api-key-types';
import { Nullable } from 'common-types';

const CreateApiKeyModal: FC<
  React.PropsWithChildren<CreateApiKeyModalProps>
> = props => {
  const theme = useTheme();

  const {
    open,
    onClose,
    onCreateApiKey,
    apiKeyRoleTypes,
    isInviteButtonLoading,
    errorMessage,
    keySecret,
  } = props;

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label='Create API Key'
      open={open}
      onClose={onClose}
      modalHeader='Create API Key'>
      <CreateApiKeyForm
        onCreateApiKey={onCreateApiKey}
        onClose={onClose}
        apiKeyRoleTypes={apiKeyRoleTypes}
        isLoading={isInviteButtonLoading}
        errorMessage={errorMessage}
        keySecret={keySecret}
      />
    </ModalDialog>
  );
};

interface CreateApiKeyModalProps {
  open: boolean;
  onClose: () => void;
  onCreateApiKey: (createApiKeyInput: CreateApiKeyInput) => void;
  apiKeyRoleTypes: ApiKeyRoleType[];
  isInviteButtonLoading: boolean;
  errorMessage: Nullable<string>;
  keySecret: Nullable<string>;
}

export default CreateApiKeyModal;
